import type { GetDesignerNodeById } from "../../state/index.ts";
import type { DesignerNode, ValueDescriptor } from "../../types/index.ts";
import type { GetNodeValues } from "./getNodeValues.ts";

interface CreateOptions {
  getById: GetDesignerNodeById;
  getNodeValues: GetNodeValues;
}

export interface NodeValueId {
  nodeId: number;
  name: string;
}

export interface ResolvedNodeValue {
  node: DesignerNode;
  descriptor: ValueDescriptor;
}

/**
 * Look up a single advertised value by its producing node and name. Returns
 * undefined when the node no longer exists or no longer advertises the value —
 * the producer's veto, mirroring condition buildables.
 */
export const getNodeValueCreate = ({ getById, getNodeValues }: CreateOptions) => {
  return ({ nodeId, name }: NodeValueId): ResolvedNodeValue | undefined => {
    let node: DesignerNode;
    try {
      node = getById(nodeId);
    } catch {
      // the producing node has been deleted; the stored reference dangles
      return undefined;
    }
    const descriptor = getNodeValues(node).find((value) => value.name === name);
    return descriptor && { node, descriptor };
  };
};

export type GetNodeValue = ReturnType<typeof getNodeValueCreate>;
